import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import {
  LgButtonComponent,
  LgIconComponent,
  LgSelectDirective,
  LgSelectFieldComponent
} from "@legal-and-general/canopy";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";
import { CmsData } from "@dotcom-frontend/data";
import { AnalyticsService } from "../../../services/analytics/analytics.service";
import { Store } from "@ngrx/store";
import { GlobalState } from "../../../store/global/global.reducer";
import { selectPageTitle } from "../../../store/global/global.selectors";
import { Observable } from "rxjs";
import { NgClass } from "@angular/common";

@Component({
  selector: "dotcom-frontend-quick-nav",
  templateUrl: "./QuickNav.component.html",
  styleUrl: "./QuickNav.component.scss",
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    LgSelectDirective,
    LgIconComponent,
    LgButtonComponent,
    LgSelectFieldComponent,
    NgClass
  ]
})
export class QuickNavComponent implements DynamicComponent, OnInit {
  @Input() data: CmsData | undefined;
  block = true;
  options: any = [];
  isDisabled = true;
  quickNavTarget: any;
  pageTitle = "";
  pageTitle$: Observable<string> = this.store.select(selectPageTitle);

  constructor(
    private store: Store<{ global: GlobalState }>,
    private analyticsService: AnalyticsService
  ) {
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });
  }

  ngOnInit() {
    if (this.data) {
      if (this.data["ctaButtons"]) {
        this.options = this.data["ctaButtons"];
      }
    }
  }

  handleOptionChange(e: Event) {
    this.quickNavTarget = e;

    if (this.quickNavTarget !== "Please select") {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  interactionClickEvent(clickUrl: any, clickName: any) {
    this.analyticsService.adobeInteractionEvent(
      "Quick Nav Block",
      clickUrl,
      clickName,
      "",
      "ContinueButton",
      this.pageTitle,
      ""
    );
  }
}
